import React from 'react';
import logo from '../logo.png';
import '../App.css';

function Home() {
  return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Welkom bij HuurHuisHunter
          </p>

        </header>
      </div>
  );
}

export default Home;
